import React from "react";
import IconButton, { IconButtonProps } from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import FableTooltip from "./FableTooltip";

/** The same navigation affordance in Create and Studio. */
export default function NavigationMenuButton({
  sx,
  ...props
}: Omit<IconButtonProps, "children">) {
  return (
    <FableTooltip title={props["aria-label"] || "Open navigation"}><IconButton
      aria-label="Open navigation"
      {...props}
      sx={[
        {
          width: 36,
          height: 36,
          "&&": { color: "#fff" },
          border: "none",
          bgcolor: "transparent",
          boxShadow: "none",
          "&:hover": { bgcolor: "rgba(255,255,255,0.06)" },
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      <MenuIcon sx={{ fontSize: 27 }} />
    </IconButton></FableTooltip>
  );
}
